export default __webpack_public_path__ + "static/media/nursePSAF.4dc5dd33.png";